import React, { useState, useEffect } from 'react';

const ProtectedCaseStudy = ({ children, pageName, correctPassword }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Clear authentication on page refresh
  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.removeItem(`caseStudy_${pageName}`);
    };
    
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [pageName]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === correctPassword) {
      sessionStorage.setItem(`caseStudy_${pageName}`, 'true');
      setIsAuthenticated(true);
      setError('');
      setPassword('');
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  const handleLogout = () => {
    sessionStorage.removeItem(`caseStudy_${pageName}`);
    setIsAuthenticated(false);
    setPassword('');
  };

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-dj-light to-white flex items-center justify-center px-4">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-lg shadow-xl p-8 border-t-4 border-primary">
            <h1 className="text-3xl font-bold text-dj-dark mb-2 text-center">Case Study</h1>
            <p className="text-gray-600 text-center mb-8">This content is password protected.</p>
            
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label htmlFor="password" className="block text-sm font-semibold text-dj-dark mb-2">
                  Enter Password
                </label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/20"
                  autoFocus
                />
              </div>

              {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                  {error}
                </div>
              )}

              <button
                type="submit"
                className="w-full bg-primary hover:bg-secondary text-dj-dark font-bold py-3 px-4 rounded-lg transition-colors"
              >
                Unlock Case Study
              </button>
            </form>

            <p className="text-xs text-gray-500 text-center mt-6">
              This case study is shared with selected viewers.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Authenticated - render children with logout button
  return (
    <div>
      {/* Logout button in header */}
      <div className="absolute top-4 right-4 md:top-6 md:right-20">
        <button
          onClick={handleLogout}
          className="text-sm font-semibold text-primary hover:text-secondary transition-colors px-3 py-2 rounded hover:bg-dj-light"
        >
          Logout
        </button>
      </div>
      {children}
    </div>
  );
};

export default ProtectedCaseStudy;
